export default defineNuxtPlugin((nuxtApp) => {
	nuxtApp.provide("dates", {
		$formatUTCDate: (utcDateString) => {
			const date = new Date(utcDateString)
			const year = date.getFullYear()
			const month = String(date.getMonth() + 1).padStart(2, "0")
			const day = String(date.getDate()).padStart(2, "0")
			// Format as YYYY-MM-DD
			return `${year}-${month}-${day}`
		},

		$formatToReadFriendly: (dateString) => {
			// Preserve calendar dates without converting through the viewer's timezone.
			const options = { year: "numeric", month: "short", day: "numeric", timeZone: "UTC" }
			const date = new Date(dateString + "T00:00:00Z")
			return date.toLocaleString("en-US", options)
		},
	})
})
